import { useMemo, useState } from "react";
import { ImporterContext, PreviewedRow } from "./importer.context";
import { ImporterDocumentRow } from "./types";

interface Props {
    children: React.ReactNode;
}

export const ImporterContextProvider: React.FC<Props> = ({ children }) => {
    const [documentRows, setDocumentRows] = useState<ImporterDocumentRow[]>([]);
    const [previewedRow, setPreviewedRow] = useState<
        PreviewedRow | undefined
    >();

    const addDocumentRow = (documentRow: ImporterDocumentRow) => {
        setDocumentRows((prevDocumentRows) => [
            ...prevDocumentRows,
            documentRow,
        ]);
    };

    const removeDocumentRow = (documentRow: ImporterDocumentRow) => {
        setDocumentRows((prevDocumentRows) =>
            prevDocumentRows.filter((d) => d !== documentRow),
        );
    };

    const updateDocumentRow = (
        id: string,
        documentRow: Partial<Omit<ImporterDocumentRow, "id">>,
    ) => {
        setDocumentRows((prevDocumentRows) =>
            prevDocumentRows.map((d) =>
                d.id === id ? { ...d, ...documentRow } : d,
            ),
        );
        setPreviewedRow((prevValue) => {
            if (prevValue?.id === id) {
                return {
                    id,
                    financialDocument:
                        documentRow.financialDocument ??
                        prevValue.financialDocument,
                    integrationAccount:
                        documentRow.integrationAccount ??
                        prevValue.integrationAccount,
                };
            }
            return prevValue;
        });
    };

    const context = useMemo(
        () => ({
            documentRows,
            addDocumentRow,
            removeDocumentRow,
            updateDocumentRow,
            previewedRow,
            setPreviewedRow,
        }),
        [documentRows, previewedRow],
    );

    return (
        <ImporterContext.Provider value={context}>
            {children}
        </ImporterContext.Provider>
    );
};
